import { render, staticRenderFns } from "./BlogSettings.vue?vue&type=template&id=288139ab&scoped=true"
import script from "./BlogSettings.vue?vue&type=script&lang=js"
export * from "./BlogSettings.vue?vue&type=script&lang=js"
import style0 from "./BlogSettings.vue?vue&type=style&index=0&id=288139ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288139ab",
  null
  
)

export default component.exports